import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptChairmanNewAndOldLists } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import _ from 'lodash'
import { ThY } from '@utils/utils'
import { Card, Flex, List, Title } from '@mantine/core'

const ChairmanNewAndOldLists = ({ title, data }: { title: string; data: IResponseOptChairmanNewAndOldLists }) => {
  const _data = _.groupBy(data, (a) => a.budget_year)
  const tableData = Object.keys(_data).map((year) => {
    const newAgencies: IResponseOptChairmanNewAndOldLists = []
    const oldAgencies: IResponseOptChairmanNewAndOldLists = []
    _data[year].forEach((list) => {
      if (list.chairman_type === 'new') newAgencies.push(list)
      else oldAgencies.push(list)
    })
    return { budget_year: year, newAgencies, oldAgencies }
  })
  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      <Flex direction="column" gap="xl">
        {tableData.map((r) => (
          <div key={r.budget_year}>
            {tableData.length > 1 && <TextChartTitle mb="sm">{title + ' ประจำปีงบประมาณ ' + ThY(r.budget_year)} </TextChartTitle>}
            <Flex gap="md">
              <Card shadow="md" withBorder w="50%">
                <Title order={5} mb="sm">
                  ประธานโครงการรายเก่า
                </Title>
                <List type="ordered">
                  {r.oldAgencies.map((chairman, index) => (
                    <List.Item key={index}>{chairman.chairman_fullname}</List.Item>
                  ))}
                  {!r.oldAgencies.length && <div>ไม่มีข้อมูล</div>}
                </List>
              </Card>
              <Card shadow="md" withBorder w="50%">
                <Title order={5} mb="sm">
                  ประธานโครงการรายใหม่
                </Title>
                <List type="ordered">
                  {r.newAgencies.map((chairman, index) => (
                    <List.Item key={index}>{chairman.chairman_fullname}</List.Item>
                  ))}
                  {!r.newAgencies.length && <div>ไม่มีข้อมูล</div>}
                </List>
              </Card>
            </Flex>
          </div>
        ))}
      </Flex>
    </ChartFlexSection>
  )
}

export default ChairmanNewAndOldLists
